import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LocImage from "../../assets/Group 403.svg";
import { UserContext } from "../../use_context";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function ContactCareer() {
  // const [career, setCareer] = useState([]);
  const { career, setCareer } = useContext(UserContext);

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (career?.length > 0) return;
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${API_BASE_URL}/pages/110`);

        const data = response.data;

        const careerData = Array.isArray(data?.acf?.career)
          ? data.acf.career
          : [];

        setCareer(careerData);
      } catch (error) {
        console.error("Error fetching data", error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();

  return (
    <div>
      <div className="py-5 leadership-align career-padding">
        <h2 className="mb-4 fw-bold text-center">Career Openings</h2>

        {isLoading && <p>Loading...</p>}
        {!isLoading && career?.length === 0 && <p>No job openings found.</p>}
        {error && <p>Error fetching job data. Please try again later.</p>}

        {career?.map((job, index) => (
          <Row key={index} className="align-items-center py-3 border-bottom">
            <Col md={8}>
              <h5 className="fw-semibold mb-1">{job.career_title}</h5>
              <div>{job.career_desc}</div>
              <div>{job.career_date}</div>
            </Col>
            <Col md={4} className="text-end">
              <div className="mb-3 d-flex justify-content-end align-items-center ">
                <img
                  src={LocImage}
                  height={20}
                  width={20}
                  alt="loc icon"
                  className="loc-icon me-2"
                />
                <span className="career_location_text">
                  {job.career_location}
                </span>{" "}
              </div>
              <Button
                onClick={() => navigate(`/job-details/${index}`)}
                variant="outline-dark"
              >
                {job.career_button}
              </Button>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}

export default ContactCareer;
